import { ChangeDetectionStrategy, Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { ownedError } from 'core/utils/owned-error';
import { Ordering } from 'shared/criteria/Criteria';

@Component({
  selector: 'app-simple-sort',
  styles: [`
      .sort-column {
          cursor: pointer;
      }

      .sort-column:hover {
          color: rgba(24, 130, 179, 0.82);
      }

      .active-column-sort {
          color: rgba(24, 130, 179, 0.82);
      }
  `],
  template: `
    <span (click)="changeSort()" [matTooltipHideDelay]="1000" [ngClass]="{ 'active-column-sort': isActive('asc') || isActive('desc') }"
      class="sort-column" [matTooltip]="'CONTROLS.sort' | translate">
      <ng-content></ng-content>
      @if (isActive('asc')) {
        <mat-icon [inline]="true">arrow_upward</mat-icon>
      }
      @if (isActive('desc')) {
        <mat-icon [inline]="true">arrow_downward</mat-icon>
      }
    </span>
    `,
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false,
})
export class SimpleSortHeaderComponent implements OnInit {
  @Input() ordering?: Ordering;
  @Output() orderingChange = new EventEmitter<Ordering>();

  @Input() field!: string;

  ngOnInit(): void {
    if (!this.field) {
      throw ownedError(new Error('columnName is not provided'));
    }
  }

  changeSort(): void {
    if (!this.ordering) {
      this.ordering = { field: this.field, ascending: 'desc' };
    }
    else if (this.ordering.ascending === 'desc') {
      this.ordering = { field: this.field, ascending: 'asc' };
    }
    else {
      this.ordering = undefined;
    }

    this.orderingChange.emit(this.ordering);
  }

  isActive(ascending: string): boolean | undefined {
    return this.ordering && ascending === this.ordering.ascending && this.field === this.ordering.field;
  }
}
